// Fabero housing listings (Casas tab); the app's villageListings.ts is generated from this file.

export const housesGraus = [
  {
    images: [
      { url: "https://aldealista.com/news/fabero/houses/01/01.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/02.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/03.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/04.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/05.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/06.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/07.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/08.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/01/09.jpg" },
    ],
    url: "https://www.idealista.com/inmueble/105401764/",
    address: "Jesús y María, 1",
    contact: "",
    title: "Alquiler de Piso, Fabero",
    description:
      "A un minuto a pié de la plaza del Ayuntamiento, cuenta con tres habitaciones, un baño, cocina amplia con vitrocerámica, frigorífico combi, microondas y horno, salón comedor y terraza cubierta. Está bien aislado, prácticamente no necesita usar calefacción. Calefacción central de aerotermia, el uso de la calefacción y agua caliente se regula mediante termostato y se paga por energía usada.\n\nAgua e Internet incluido en el precio.\n\nAbastecimiento de luz mediante prepago, sin necesidad de darse de alta en ninguna compañía.\n\nTambién hay posibilidad de alquilar por días o semanas.\n\n",
    size: "154",
    price: "490",
  },
  {
    images: [
      { url: "https://aldealista.com/news/fabero/houses/02/01.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/02.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/03.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/04.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/05.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/06.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/07.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/08.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/09.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/10.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/11.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/12.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/13.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/14.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/15.jpg" },
      { url: "https://aldealista.com/news/fabero/houses/02/16.jpg" },
    ],
    url: "https://www.fincasgraus.com/inmueble/chalet-adosado-en-venta-en-graus/21461877",
    address: "Real, 36",

    contact: "974 546 536",
    title: "Alquiler de piso, Fabero",
    description:
      "Calefacción-agua caliente con Gasoil. Faltaría ropa de cama para dos de las habitaciones que están amuebladas y utensilios (platos, cubiertos, etc... )para la cocina. Después hay dos huecos que se pueden habilitar de oficina, zona de plancha o habitaciones. Estos dos huecos están sin amueblar.",
    size: "160",
    price: "485",
  },
];
